/**
 * What every surface that paints the tree's lights shares (§4.17): the
 * normalized canopy the server lays a window out in, and how bright one light
 * burns. Held here rather than in BanyanScene because a place page's Nearby
 * list paints the same lights on paper and the two must never drift.
 */

/** Mirrors life-nodes.js CANOPY; the server never sees scene units. */
export const CANOPY_NORM = Object.freeze({ cx: 0.5, cy: 0.42, rx: 0.47, ry: 0.36 });

/**
 * Brightness follows how many people stood at a light. SIZE never does — no
 * Matthew effect on the tree (2026-09-05 拍板), so a light with a hundred
 * people behind it is brighter than one with three and exactly as big.
 * A focused light is drawn at full brightness whatever its count: the page or
 * the window is about that one node, not about how crowded it is.
 */
export function lampAlpha(peopleCount: number): number {
  const weight = Math.min(3, Math.log2(Math.max(1, peopleCount)) / 2);
  // Rounded because the place page writes this straight into an inline style
  // the server renders too — three decimals is finer than a screen can show
  // and keeps the markup (and any hydration diff) honest.
  return Math.round((0.55 + weight * 0.15) * 1000) / 1000;
}
